import { Component, QueryList, ViewChild, ViewChildren, ElementRef } from '@angular/core';
import { CoDiscoverLaneComponent } from '../../components/co-discover-lane/co-discover-lane';
import { CoDiscoverExploreComponent } from '../../components/co-discover-explore/co-discover-explore';
import { Platform } from 'ionic-angular';
import { AppState } from '../../config/state';

/**
 * Generated class for the CoDiscoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-discover',
  templateUrl: 'co-discover.html'
})
export class CoDiscoverComponent {
  @ViewChild('catlist') catlist: ElementRef;
  private term: string;
  private lastSearch: string;
  private lastIndex: string;
  private cats: Object;
  private showSuggest: boolean;
  private results:Array<any>;
  private indexName: string;
  private suggestions:Array<any>;
  viewType: any; //lint issue solution
  @ViewChildren('lane') lanes:QueryList<CoDiscoverLaneComponent>;
  @ViewChild('explore') explore:CoDiscoverExploreComponent;

  constructor(private platform: Platform, private state: AppState) {
    this.viewType = this.state.mode;
    this.indexName = "Explore";
    this.cats = {
      "Read":
          ['Books','Kits','Graphic Format','Maps','Playaway','Large Print','Magazine','Microform','eBook','eDatabase','eMagazine', 'Comic'],
      "Play":
          ['Toy','Video game'],
      "Watch":
          ['Video','DVD','Blu-Ray','eVideo', 'Playaway Views'],
      "Listen":
          ['Audiobook','CD-Book','CD','eMusic','Score','eAudio']
      };

  }
  public update(){
    if(this.explore)this.explore.update();
    this.lanes.forEach(lane=>lane.update());
  }
  toggleSuggest(state){
    setTimeout(()=>{
      this.showSuggest=state;
    }, 100);
  }
  suggestSearch(term){
    this.term=term;
    this.search(false);
  }
  private search(inclideSuggestions){
    this.results=[];
    this.suggestions = [];
    if(!this.term || this.term.length === 0) return;
    if(this.lastSearch === this.term && this.lastIndex === this.indexName)return;
    let queries=[];
    this.lastSearch = this.term;
    this.lastIndex = this.indexName;
    if( this.indexName==='Explore'){
      for (let cat in this.cats) {
        queries = queries.concat(this.getQueries(cat));
      }
    }else{
      queries = this.getQueries(this.indexName);
    }

    //this.algolia.search.search(queries).then(content=>{
    //  const r = content.results.filter(result=>result.nbHits>0).reduce((res, result)=>{
    //    res[result.hits[0].f] = result;
    //    return res;
    //  }, {});
    //  this.lanes.forEach(lane=>{
    //    lane.initResults(r[lane.name]||false);
    //  });
    //  setTimeout(this.sortLanes.bind(this), 0);
    //
    //  // self.results = _.orderBy(content.results.filter(result=>result.nbHits>0).map(result=>({name:result.hits[0].f, result:result})), 'result.nbHits', 'desc');
    //}).catch(err=>{console.error(err)});

    if(inclideSuggestions)this.updateSuggestions(this.term);
  }
  private updateSuggestions(term){
    //this.algolia.search.search([{
    //  indexName:'items',
    //  query: term,
    //  params: {
    //    restrictSearchableAttributes:["pa"],
    //    attributesToRetrieve:["pa"],
    //    attributesToHighlight: ['pa'],
    //    hitsPerPage:100
    //  }
    //},{
    //  indexName:'items',
    //  query: term,
    //  params: {
    //    restrictSearchableAttributes:["ti"],
    //    attributesToRetrieve:["ti"],
    //    attributesToHighlight: ['ti'],
    //    hitsPerPage:100
    //  },
    //}]).then(content=>{
    //  this.suggestions = [];
    //  if(content.results[0].hits.length>0){
    //    this.suggestions.push({
    //      name: "Author",
    //      items: content.results[0].hits.map(suggestion=>{
    //        let initals = suggestion.pa.split(" ").map((n)=>n[0]).slice(0,3).join("");
    //        return {'text':suggestion.pa, 'display':'<img src="http://via.placeholder.com/20/666666/ffffff?text='+initals+'"/>'+suggestion._highlightResult.pa.value}
    //      }).filter((obj, pos, arr) => {
    //        return arr.map(mapObj => mapObj['text']).indexOf(obj['text']) === pos;
    //      }).slice(0, 5)
    //    });
    //  }
    //  if(content.results[1].hits.length>0){
    //    this.suggestions.push({
    //      name: "Title",
    //      items: content.results[1].hits.map(suggestion=>{
    //        return {'text':suggestion.ti, 'display':suggestion._highlightResult.ti.value}
    //      }).filter((obj, pos, arr) => {
    //        return arr.map(mapObj => mapObj['text']).indexOf(obj['text']) === pos;
    //      }).slice(0, 7)
    //    });
    //  }
    //
    //
    //}).catch(err=>{console.error(err)});
  }
  sortLanes(){
    let x = 0;
    const xSize = this.platform.width()<768?238:338;
    Array.prototype.slice.call(this.catlist.nativeElement.querySelectorAll('.sorted')).sort((a,b)=>{
      const an = parseInt(a.querySelectorAll('.discoverSetTitle')[0].dataset['hits'], 10);
      const bn = parseInt(b.querySelectorAll('.discoverSetTitle')[0].dataset['hits'], 10);
     if(an<bn) return 1;
     if(an>bn) return -1;
     return 0;
    }).forEach(div=>{
      div.style.top = x+'px';
      x+=xSize;
      // div.parentElement.appendChild(div);
    });
    setTimeout(this.update.bind(this), 750);
  }
  getQueries(set){
    let queries = [];
    this.cats[set].forEach(element => {
      queries.push({
          indexName:'items',
          params: {
              facets: ["f"],
              facetFilters: ['f:'+element],
              attributesToRetrieve:["ti", "ids", "objectID", "src", "f"],
            },
          query: this.term,
      });
  });
  return queries;
  }
}



// WEBPACK FOOTER //
// ./src/components/co-discover/co-discover.ts